import {gql} from '@apollo/client';

export const tenantMutations = {
    UPDATE_TENANT_USER_IS_DEFAULT: gql`
        mutation UpdateTenantUserIsDefault($request: TanentUserRequestInput!) {
            updateTenantUserIsDefault(request: $request) {
                updatedTanentId
                jwtToken
                boardSlug
                workspaceSlug
                updatedTanentSlug
                workspaceSettings {
                    id
                    uniqueId
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                }
                tenantSettings {
                    id
                    uniqueId
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                }
                boardSettings {
                    id
                    uniqueId
                    value {
                        value
                        selectedOption {
                            label
                            value
                            color
                            textColor
                        }
                        multiSelectedOptions {
                            label
                            value
                            color
                            textColor
                        }
                        booleanValue
                        integerValue
                    }
                }
            }
        }
    `,
    REMOVE_USERS_FROM_TENANT: gql`
        mutation RemoveUsersFromTenant($request: UserIdsForTenantRequestInput!) {
            removeUsersFromTenant(request: $request) {
                data
                message
                statusCode
                success
            }
        }
    `,
    ADD_USERS_TO_TENANT: gql`
        mutation AddUsersToTenant($request: UserIdsForTenantRequestInput!) {
            addUsersToTenant(request: $request) {
                data
                message
                statusCode
                success
            }
        }
    `,
};
